// extracted by mini-css-extract-plugin
export default {"creditsList":"Os478N8M","creditAvatar":"_2EBHfvvY","coverImage":"_3cyNydR4","projectCard":"_38mVSIA2","markdownPreview":"_1Lq7csMU","fadeout":"_1EmVvPfD"};